<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2019-11-14',
        major: [],
        items: [

          // [NOTE] HR
          // ================================================================================

          item({
            collection  : 'プリチケパック3',
            id          : 'AM-329',
            rare        : 'HR',
            name        : 'かぐやひめるりいろドレス',
            imgUrl      : '/images/items/AM-329.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-330',
            rare        : 'HR',
            name        : 'かぐやひめるりいろシューズ',
            imgUrl      : '/images/items/AM-330.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-331',
            rare        : 'HR',
            name        : 'かぐやひめるりいろヘアアクセ',
            imgUrl      : '/images/items/AM-331.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'HR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : 'プリチケパック3',
            id          : 'AM-280',
            rare        : 'PR',
            name        : 'エジプトクイーントップス',
            imgUrl      : '/images/items/AM-280.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-281',
            rare        : 'PR',
            name        : 'エジプトクイーンスカート',
            imgUrl      : '/images/items/AM-281.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-282',
            rare        : 'PR',
            name        : 'エジプトクイーンシューズ',
            imgUrl      : '/images/items/AM-282.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 2 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-283',
            rare        : 'PR',
            name        : 'エジプトクイーンヘアアクセ',
            imgUrl      : '/images/items/AM-283.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-284',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーアナザーワンピ',
            imgUrl      : '/images/items/AM-284.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-285',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーアナザーシューズ',
            imgUrl      : '/images/items/AM-285.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-286',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-286.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'PR',
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-287',
            rare        : 'PR',
            name        : 'ゆめサイリウムしゅうかアナザーワンピ',
            imgUrl      : '/images/items/AM-287.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-288',
            rare        : 'PR',
            name        : 'ゆめサイリウムしゅうかアナザーシューズ',
            imgUrl      : '/images/items/AM-288.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-289',
            rare        : 'PR',
            name        : 'ゆめサイリウムしゅうかアナザーヘアアクセ',
            imgUrl      : '/images/items/AM-289.png',
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'PR',
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : 'プリチケパック3',
            id          : 'AM-290',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドパープルトップス',
            imgUrl      : '/images/items/AM-290.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-291',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドパープルスカート',
            imgUrl      : '/images/items/AM-291.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-292',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドパープルシューズ',
            imgUrl      : '/images/items/AM-292.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-293',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドパープルヘアアクセ',
            imgUrl      : '/images/items/AM-293.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-294',
            rare        : 'SR',
            name        : 'ベイビーモンスターピンクサイリウムワンピ',
            imgUrl      : '/images/items/AM-294.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-295',
            rare        : 'SR',
            name        : 'ベイビーモンスターピンクサイリウムスカート',
            imgUrl      : '/images/items/AM-295.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-296',
            rare        : 'SR',
            name        : 'ベイビーモンスターピンクサイリウムシューズ',
            imgUrl      : '/images/items/AM-296.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'SR',
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-297',
            rare        : 'SR',
            name        : 'フォーチュンパーティパープルサイリウムワンピ',
            imgUrl      : '/images/items/AM-297.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-298',
            rare        : 'SR',
            name        : 'フォーチュンパーティパープルサイリウムシューズ',
            imgUrl      : '/images/items/AM-298.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-299',
            rare        : 'SR',
            name        : 'フォーチュンパーティパープルサイリウムヘアアクセ',
            imgUrl      : '/images/items/AM-299.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'SR',
          }),


          // [NOTE] R
          // ================================================================================

          item({
            collection  : 'プリチケパック3',
            id          : 'AM-300',
            rare        : 'R',
            name        : 'カラフルクッキングキウイトップス',
            imgUrl      : '/images/items/AM-300.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-301',
            rare        : 'R',
            name        : 'カラフルクッキングキウイスカート',
            imgUrl      : '/images/items/AM-301.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-302',
            rare        : 'R',
            name        : 'カラフルクッキングキウイシューズ',
            imgUrl      : '/images/items/AM-302.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-303',
            rare        : 'R',
            name        : 'カラフルクッキングキウイヘアアクセ',
            imgUrl      : '/images/items/AM-303.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-304',
            rare        : 'R',
            name        : 'ハロウィンマジカルブルートップス',
            imgUrl      : '/images/items/AM-304.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-305',
            rare        : 'R',
            name        : 'ハロウィンマジカルブルースカート',
            imgUrl      : '/images/items/AM-305.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-306',
            rare        : 'R',
            name        : 'ハロウィンマジカルブルーシューズ',
            imgUrl      : '/images/items/AM-306.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-307',
            rare        : 'R',
            name        : 'ハロウィンマジカルブルーヘアアクセ',
            imgUrl      : '/images/items/AM-307.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-308',
            rare        : 'R',
            name        : 'おやすみひつじピンクトップス',
            imgUrl      : '/images/items/AM-308.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-309',
            rare        : 'R',
            name        : 'おやすみひつじピンクスカート',
            imgUrl      : '/images/items/AM-309.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-310',
            rare        : 'R',
            name        : 'おやすみひつじピンクシューズ',
            imgUrl      : '/images/items/AM-310.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-311',
            rare        : 'R',
            name        : 'おやすみひつじピンクヘアアクセ',
            imgUrl      : '/images/items/AM-311.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-312',
            rare        : 'R',
            name        : 'セブンスコーデポップドレスアナザースタイル',
            imgUrl      : '/images/items/AM-312.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 7 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-313',
            rare        : 'R',
            name        : 'セブンスコーデポップシューズアナザースタイル',
            imgUrl      : '/images/items/AM-313.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-314',
            rare        : 'R',
            name        : 'セブンスコーデポップヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-314.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'R',
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-315',
            rare        : 'R',
            name        : 'セブンスコーデエスニックドレスアナザースタイル',
            imgUrl      : '/images/items/AM-315.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-316',
            rare        : 'R',
            name        : 'セブンスコーデエスニックシューズアナザースタイル',
            imgUrl      : '/images/items/AM-316.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 5 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-317',
            rare        : 'R',
            name        : 'セブンスコーデエスニックヘアアクセプラチナスタイル',
            imgUrl      : '/images/items/AM-317.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : 'プリチケパック3',
            id          : 'AM-318',
            rare        : 'N',
            name        : 'レトロストライプブラウントップス',
            imgUrl      : '/images/items/AM-318.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 9 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-319',
            rare        : 'N',
            name        : 'レトロストライプブラウンスカート',
            imgUrl      : '/images/items/AM-319.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-320',
            rare        : 'N',
            name        : 'レトロストライプブラウンシューズ',
            imgUrl      : '/images/items/AM-320.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-321',
            rare        : 'N',
            name        : 'レトロストライプブラウンヘアアクセ',
            imgUrl      : '/images/items/AM-321.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-322',
            rare        : 'N',
            name        : 'リトルローズさわやかトップス',
            imgUrl      : '/images/items/AM-322.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-323',
            rare        : 'N',
            name        : 'リトルローズさわやかスカート',
            imgUrl      : '/images/items/AM-323.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-324',
            rare        : 'N',
            name        : 'リトルローズさわやかシューズ',
            imgUrl      : '/images/items/AM-324.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-325',
            rare        : 'N',
            name        : 'リトルローズさわやかヘアアクセ',
            imgUrl      : '/images/items/AM-325.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 6 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'プリチケパック3',
            id          : 'AM-326',
            rare        : 'N',
            name        : 'ミステリー WITH エスコードワンピ',
            imgUrl      : '/images/items/AM-326.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-327',
            rare        : 'N',
            name        : 'ミステリー WITH エスコードスカート',
            imgUrl      : '/images/items/AM-327.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 3 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            id          : 'AM-328',
            rare        : 'N',
            name        : 'ミステリー WITH エスコードシューズ',
            imgUrl      : '/images/items/AM-328.png',
            numOwned    : { usual: 1 },
            numReleased : { usual: 4 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'プリチケパック3',
            rare        : 'N',
          }),
        ],
      }
    },

    computed: {
      itemsHR () {
        return _.where(this.items, {  rare: 'HR' })
      },

      itemsPR () {
        return _.where(this.items, {  rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.items, {  rare: 'SR' })
      },

      itemsR () {
        return _.where(this.items, {  rare: 'R' })
      },

      itemsN () {
        return _.where(this.items, {  rare: 'N' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">
    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>
    <template #col1>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
    </template>
    <template #col2>
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>
    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
    </template>
    <template #col4>
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
      <Status :date="date" :items="items" :showHR="true" />
    </template>
    <template #col5>
    </template>
    <template #col6>
    </template>
  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // (position: absolute になっている) PC 画面のみ
  .Page ::v-deep .Status {
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 20;
    }
  }
</style>
